import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "react-query";
import axiosInstance from "../../utils/axiosInstance";

const fetchData = async (url, query) => {
  const response = await axiosInstance.get(url, {
    params: {
      ...query
    },
  });
  
  const isWrapped = response.data?.data && response.data?.meta;
  
  return {
    rows: isWrapped ? response.data.data : response.data,
    totalRowCount: isWrapped ? response.data.meta.totalItems : response.data.length,
  };
};

export default function ServerPaginationDataGrid({
  name = "",
  url = "https://fakestoreapi.com/products",
  columns,
  pageSize = 10,
  query,
  paginationMode = "client" 
}) {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: pageSize,
  });

  const { data, isLoading, isFetching } = useQuery(
    [name || "paginatedData", url], 
    () => fetchData(url, query),
    {
      keepPreviousData: true,
    }
  );

  console.log({ isLoading, data });

  const rows = data?.rows || [];
  const rowCount = rows.length;

  return (
    <div style={{ height: "80vh", width: "100%", overflow: "auto" }}>
      <DataGrid
        disableColumnSorting
        disableColumnFilter
        disableColumnMenu
        disableColumnResize
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        getEstimatedRowHeight={() => 200}
        getRowSpacing={() => ({ top: 2, bottom: 2 })}
        sx={{
          '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '5px' },
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
          },
        }}
        rows={rows}
        columns={columns}
        rowCount={rowCount}
        loading={isLoading || isFetching}
        slotProps={{
          loadingOverlay: {
            variant: 'linear-progress',
            noRowsVariant: 'linear-progress',
          },
        }}
        pageSizeOptions={[10, 20, 50, 100]}
        paginationModel={paginationModel}
        paginationMode="client" 
        onPaginationModelChange={setPaginationModel}
      />
    </div>
  );
}
